import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe("pk_test_51UELdQLlrVFJWopYhSxncANLG81WU4aiGruL2OrYxxikTtvPxE9h3G7uzIZHxUBYDAqA78KF5R71a4vyKriLK9aJ00CY5zacN5");

function AddCardForm({ customerId, onCardAdded }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const handleAddCard = async () => {
    if (!stripe || !elements) return;
    setLoading(true);

    // 1. Get SetupIntent clientSecret from backend
    const res = await fetch(`${global.API_STRIPEAPI_URL}create-setup-intent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customerId }),
    });
    // Backend returns { clientSecret } on success and { error } (with a
    // non-2xx status) on failure — see stripeManage.js
    // /stripeApi/create-setup-intent. Previously we destructured
    // clientSecret without checking the status or body, so a 500 (e.g.,
    // stale/invalid customerId, Stripe account mismatch after a key
    // rotation) produced an undefined clientSecret and then
    // confirmCardSetup surfaced the misleading generic "No such
    // setupintent: 'seti_XXX'" alert. Fail fast with the actual server
    // reason so the user sees something actionable.
    const payload = await res.json().catch(() => ({}));
    const clientSecret = payload && payload.clientSecret;
    if (!res.ok || typeof clientSecret !== "string" || !clientSecret.includes("_secret_")) {
      const serverMsg = payload && (payload.error || payload.message);
      alert(
        serverMsg
          ? `Couldn't set up card: ${serverMsg}`
          : "Couldn't start card setup. Please try again."
      );
      setLoading(false);
      return;
    }

    // 2. Confirm card setup
    const cardElement = elements.getElement(CardElement);
    const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: { card: cardElement },
    });

    if (error) {
      alert(error.message);
      setLoading(false);
      return;
    }

    onCardAdded(setupIntent.payment_method);
    setLoading(false);
  };

  return (
    <div>
      <CardElement className="border p-3 rounded" />
      <button
        onClick={handleAddCard}
        disabled={loading}
        className="add-card-btn"
      >
        {loading ? "Adding..." : "Add Card"}
      </button>
    </div>
  );
}

export default function AddCard({ customerId, onCardAdded }) {
  return (
    <Elements stripe={stripePromise}>
      <AddCardForm customerId={customerId} onCardAdded={onCardAdded} />
    </Elements>
  );
}